if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      
  
      this.form = this.querySelector('form[action="/cart/add"]');
      this.submitButton = this.querySelector('[type="submit"]');
      this.productFlow = document.querySelector('product-flow-form')
  
      if (!this.form) return;
  
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
    checkboxesHandler() {
      this.productFlow.querySelectorAll('input[type="checkbox"][required]:not(:checked)').forEach(item => {
        item.classList.add('error')
        item.closest('.pdp-flow__step').scrollIntoView({ behavior: 'smooth'})
  
        setTimeout(function () {
          item.classList.remove('error')
        }, 2000)
      })
    }
    
    onSubmitHandler(e) {
      e.preventDefault();

      if (this.productFlow.querySelector('input[type="checkbox"][required]:not(:checked)') && this.productFlow.productTypes.productType !== 'sample') {
        this.checkboxesHandler()
        
        return
      }
      
      this.handleErrorMessage();
  
      this.submitButton.setAttribute('disabled', true)
      this.submitButton.innerHTML = 'Adding...'
      const randomNumber = Math.floor(Math.random() * (999 - 100)) + 100
      this.form = this.querySelector('form[action="/cart/add"]');
      
      const formItems = new URLSearchParams(new FormData(this.form))
      
      for (const [key, value] of formItems) {
        console.log(`${key}: ${value}\n`);
      }
      
      const formData = {
        items: [
          {
            id: formItems.get('id'),
            quantity: parseInt(formItems.get('quantity'))
          }
        ]
      };
      
      const idSelector = document.querySelectorAll(`[name="id"][value="${formItems.get('id')}"]`);
      
      if (idSelector.length && idSelector[0].hasAttribute('data-property-message')) {
        formData.items[0].properties = {
          'Backorder until': idSelector[0].getAttribute('data-property-message'),
        }
      }
      
      if (formItems.get('properties[Window / Soffit wrapping]') && formItems.get('properties[Window / Soffit wrapping]') === 'yes') {
        formData.items[0].properties = {
          ...formData.items[0]?.properties || {},
          ...{
            'Window / Soffit wrapping': 'yes',
          }
        }
      }
      
      if (formItems.get('properties[Rush Processing]')) {
        formData.items[0].properties = {
          ...formData.items[0]?.properties || {},
          ... {
            'Rush Processing': formItems.get('properties[Rush Processing]'),
            '_uniq-id': formItems.get('id') + randomNumber
          }
        }
      }
      
      if (formItems.get('properties[Sample size]')) {
        formData.items[0].properties = {
          'Sample size': formItems.get('properties[Sample size]'),
        }
      }
      
      if (formItems.get('processing_id')) {
        formData.items.unshift({
          id: formItems.get('processing_id'),
          quantity: 1,
          properties: {
            '_related-uniq-id': formItems.get('id') + randomNumber
          }
        })
      }
      
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }
      
      
      fetch(window.Shopify.routes.root + 'cart/add.js', config)
        .then((response) => response.json())
        .then((response) => {
          this.updateCartIcon()
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.removeAttribute('disabled')
          this.submitButton.innerHTML = 'Add to Cart'
        });
    }
  
    updateCartIcon() {
      const cartIcons = [...document.querySelectorAll('.cart-count')];
      const shoppingBags = [...document.querySelectorAll('.shopping_bag')];
    
      shoppingBags.forEach(shoppingBag => {
        shoppingBag.classList.add('bounce');
      });
    
      cartIcons.forEach(cartIcon => {
        cartIcon.innerHTML = (+cartIcon.innerHTML.trim() + 1).toString();
      })
    }
    
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }
  
  customElements.define('product-form', ProductForm);
}